module.exports = __webpack_public_path__ + "static/img/科技治超1.56e2e7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/buliding/科技治超1.png
// module id = s4S0
// module chunks = 1